import React from 'react';
import '../pages/styles/FormPageStyles.css'; 

const ReusableForm = ({ title, error, successMessage, handleSubmit, children, submitButtonText, submitButtonDisabled, imageSrc, afterButtonContent }) => {
  return (
    <div className="register-page-container"> 
      <div className="register-form-card">
        {imageSrc && <img src={imageSrc} alt="Form Logo" className="form-logo" />}
        <h2 className="app-title">TICKETERA APP</h2>
        <h2 className="form-subtitle">{title}</h2>
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}
        <form onSubmit={handleSubmit} className="register-form">
          {children} {/* Aquí se insertarán los campos específicos del formulario */}
          <button type="submit" className="submit-btn" disabled={submitButtonDisabled}>{submitButtonText}</button>
          {afterButtonContent && <div className="after-button-content">{afterButtonContent}</div>} {/* Contenido después del botón */}
        </form>
      </div>
    </div>
  );
};

export default ReusableForm; 